import styled from 'styled-components';

import {getColor, ms, square} from '../../../styles';
import {View} from '../../View';
import {type CheckboxV2} from './Checkbox.v2';

export const DEFAULT_SIZE = 20;

export const Container = styled(View)<CheckboxV2.StyledProps>`
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  border: ${ms(1)} solid ${getColor('border.middle')};
  ${p => square(p.size || DEFAULT_SIZE)};
  position: relative;
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  border-radius: ${p => ms((p.size || DEFAULT_SIZE) / 5)};
  background-color: transparent;
  opacity: ${p => (p.disabled ? 0.5 : 1)};
`;
